import type { Appointment } from "@medplum/fhirtypes";
import { APPOINTMENT_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Appointment resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useAppointmentSubscription = createSubscriptionHook<Appointment>(
  "Appointment",
  APPOINTMENT_COLLECTION_NAME,
);
